// extracted by mini-css-extract-plugin
export default {"card":"InvoiceCard_card__MRPRR","space-between":"InvoiceCard_space-between__-jASI","total":"InvoiceCard_total__xpYH5","color":"InvoiceCard_color__9R6mw"};